import { useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import AgentBuyerPool from "./AgentBuyerPool";

const AgentFUBIntegration = () => {
  const { companyId } = useParams();

  return (
    <div className="m-4">
      <Breadcrumb
        title="Follow Up Boss - Buyer Pool"
        items={[
          { title: "Dashboard", href: `/company/${companyId}/agent/dashboard` },
          {
            title: "Integrations",
            href: `/company/${companyId}/agent/integrations`,
          },
          { title: "Follow Up Boss" },
        ]}
      />
      <div className="mt-4">
        <AgentBuyerPool embedded />
      </div>
    </div>
  );
};

export default AgentFUBIntegration;
